import _ from 'lodash';
import moment from 'moment';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Redirect } from 'react-router-dom';

import {
  Page,
  StarRating,
} from '../shared';

import {
  ConfirmModal
} from '../modals';

import {
  getSellingCompetency,
  sellingCompetencies,
  scrollTop,
  emulatingDevelopment,
  isDevelopment,
  navPrefix
} from '../../util';

import {
  fetchSalesCompetencyReviewItems,
  fetchSalesCompetencyReview,
  updateSalesCompetencyReview,
  completeSalesCompetencyReview,
} from '../../actions/salesCompetencyReviews';

import {
  ScoredCriticalExpertiseItemsSelector
} from '../../selectors';

const LIKERT_RATING_EXPLANATIONS = [
  'Very Strongly Disagree',
  'Strongly Disagree',
  'Disagree',
  'Neutral',
  'Agree',
  'Strongly Agree',
  'Very Strongly Agree',
];

const RATING_TIERS = [
  {
    value: 1,
    label: 'Beginner',
    competencyDescription: 'Bottom 25% of sellers fall into this tier, and should seek assistance in COMPETENCY_PLACEHOLDER whenever possible. These individuals have a lot to learn and should prioritize improvement in COMPETENCY_PLACEHOLDER at every opportunity. While NAME_PLACEHOLDER might be making progress, they still have many areas that are underdeveloped and are severly inhibiting their ability to meet objectives and win business.',
    description: 'Bottom 25% of sellers fall into this tier.',
    proportion: 25,
  },
  {
    value: 2,
    label: 'Novice',
    competencyDescription: 'Bottom 50% are in or below this tier. These individuals lack proficiency in COMPETENCY_PLACEHOLDER and often face challenges that require the assistance of others and/or result in missed opportunities. While NAME_PLACEHOLDER might be making decent progress in this cateogry, they have many areas for improvement in order to utilize COMPETENCY_PLACEHOLDER to win business consistently.',
    description: 'Bottom 50% of sellers fall into this tier.',
    proportion: 25,
  },
  {
    value: 3,
    label: 'Intermediate',
    competencyDescription: 'Top 50% of all sellers are in or above this tier. These individuals possess some proficiency in COMPETENCY_PLACEHOLDER, but often face challenges that require the assistance of others or result in missed opportunities. While NAME_PLACEHOLDER has noticeable strengths in this area, they also have several areas for improvement that need to be worked on before they can reliably utilize COMPETENCY_PLACEHOLDER to win business consistently.',
    description: 'Top 50% of sellers fall into this tier.',
    proportion: 25,
  },
  {
    value: 4,
    label: 'Advanced',
    competencyDescription: 'Top 25% of all sellers are in or above this tier. These individuals possess many proficiencies in COMPETENCY_PLACEHOLDER, but occasionally face challenges that require the assistance of others or result in missed opportunities. While NAME_PLACEHOLDER has many strengths in this area, they also have noticeable areas for improvement that need to be worked on before they can reliably utilize COMPETENCY_PLACEHOLDER to win business consistently.',
    description: 'Top 25% of sellers fall into this tier.',
    proportion: 15,
  },
  {
    value: 5,
    label: 'Professional',
    competencyDescription: 'Top 10% of all sellers are in or above this tier. These individuals possess extreme proficiency in COMPETENCY_PLACEHOLDER, and often these strengths directly contribute to improved win rates and velocity, as well as the seller’s ability to consistently hit their numbers. While there is still room for improvement, NAME_PLACEHOLDER is able to consistently utilize their strengths in this category to win business and very rarely struggles in COMPETENCY_PLACEHOLDER.',
    description: 'Top 10% of sellers fall into this tier.',
    proportion: 5,
  },
  {
    value: 6,
    label: 'Expert',
    competencyDescription: 'Top 5% of all sellers are in or above this tier. These individuals possess extreme proficiency in COMPETENCY_PLACEHOLDER, and often these strengths directly contribute to improved win rates and deal velocity, as well as the seller’s ability to consistently hit their numbers. NAME_PLACEHOLDER’s tactics for COMPETENCY_PLACEHOLDER should be emulated across our organization.',
    description: 'Top 5% of sellers fall into this tier.',
    proportion: 4,
  },
  {
    value: 7,
    label: 'Best in Class',
    competencyDescription: 'Very few exceptional sellers are best in class in any selling competency, let alone multiple. These are generally the most talented individuals you have come across in your career. This seller\'s tactics in this selling competency should be emulated across our organization. On more than one occasion NAME_PLACEHOLDER has taught you something new about COMPETENCY_PLACEHOLDER.',
    description: 'Only very few elite sellers fall into this tier.',
    proportion: 1,
  },
];

class EditingReview extends Component {

  state = {
    currentReviewPage: 0,
    responses: {},
    hoveringTier: null,
    redirectTo: false,
    hasConfirmedResearchQuestionExplanation: false,
  }

  reviewPages(){

    const {
      isOwnReview,
      predictiveSkillsItems,
      scoredCriticalExpertiseItems,
    } = this.props;

    const salesCompetencyReviewItemsForCurrentUser = _.filter(predictiveSkillsItems, ({ audience }) => {
      if(isOwnReview){
        return audience === 'both' || audience === 'seller';
      }
      else{
        return audience === 'both' || audience === 'manager';
      }
    });

    const sortedItems = _.sortBy(salesCompetencyReviewItemsForCurrentUser, 'questionIndex');//sort by question index to preserve intended order
    const expertiseReviewItems = this.props.scoredCriticalExpertiseItems;

    if(!(_.size(sortedItems) > 0 && _.size(expertiseReviewItems) > 0)){
      return [];
    }

    let competencyPages = [];
    let expertisePages = [];

    //for each competency review item...setup page
    const competencyReviewItems = _.filter(sortedItems, { questionType: 'competency' });
    const competencyReviewItemsByIndex = _.groupBy(competencyReviewItems, 'competencyIndex');

    _.each(competencyReviewItemsByIndex, (itemsForIndex, index) => {
      competencyPages.push({
        pageType: 'competency',
        competency: index,
        likertQuestions: _.filter(itemsForIndex, { ratingType: 'likert' }),
        tierQuestions: _.filter(itemsForIndex, {ratingType: 'tier'}),
        allQuestions: itemsForIndex,
      });
    });

    competencyPages = _.sortBy(competencyPages, page => {
      return parseInt(page.competency);
    });

    //map research and coachability items
    const coachabilityItems = _.filter(sortedItems, { questionType: 'coachability' });
    const researchItems = _.filter(sortedItems, { questionType: 'research' });

    const coachabilityPages = [{
      pageType: 'coachability',
      likertQuestions: _.filter(coachabilityItems, { ratingType: 'likert' }),
      tierQuestions: _.filter(coachabilityItems, { ratingType: 'tier' }),
      allQuestions: coachabilityItems,
    }];

    const researchPages = [{
      pageType: 'research',
      likertQuestions: _.filter(researchItems, { ratingType: 'likert' }),
      tierQuestions: _.filter(researchItems, { ratingType: 'tier' }),
      allQuestions: researchItems,
    }];

    const questionsForExpertisePage = _.map(expertiseReviewItems, item => {
      return {
        id: item.id,
        ratingType: 'likert',
        sellerText: `I am extremely effective at ${item.name}`,
        managerText: `This seller is extremely effective at ${item.name}`,
        itemDescription: item.description && item.description !== '' ? item.description : false,
      }
    });

    const tierQuestionForExpertisePage = {
      audience: 'manager',
      ratingType: 'tier',
      id: 'criticalexpertisetier',
      managerText: 'Sellers that excel at Critical Expertise possess extreme knowledge of all of the above Critical Expertise components, and know how to apply that knowledge in any situation in order to achieve deal success. Sellers extremely well versed in Critical Expertise also take advantage of opportunities to further their understanding as well as train others in the organization.'
    }

    if(isOwnReview){
      expertisePages.push({
        pageType: 'expertise',
        likertQuestions: questionsForExpertisePage,
        tierQuestions: [],
        allQuestions: questionsForExpertisePage
      });
    }
    else{
      expertisePages.push({
        pageType: 'expertise',
        likertQuestions: questionsForExpertisePage,
        tierQuestions: [tierQuestionForExpertisePage],
        allQuestions: _.union(questionsForExpertisePage, [tierQuestionForExpertisePage]),
      });
    }

    const notesFreeformQuestion = {
      id: 'notes',
    }
    const notesPage = {
      pageType: 'notes',
      notesPrompt: 'Please include any additional feedback, notes, advice, or thoughts in general that you would like to share with this seller. These will be visible to them when viewing their 180 Report, and can be utilized during your one-on-one review with this seller.',
      freeformQuestions: {
        id: 'notes',
      },
      allQuestions: [notesFreeformQuestion]
    };

    const pages = _.union(competencyPages, expertisePages, coachabilityPages, isOwnReview ? [] : [notesPage], isOwnReview ? [] : researchPages);

    //testing different order
    //const pages = _.union(researchPages, coachabilityPages, expertisePages, competencyPages);

    // console.log('competencyPages: ', competencyPages);
    // console.log('expertisePages: ', expertisePages);
    // console.log('coachabilityPages: ', coachabilityPages);
    // console.log('researchPages: ', researchPages);
    // console.log('all pages: ', pages);

    return pages;
  }

  updateRatingForQuestion(questionId, rating){

    const updatedResponses = {
      ...this.state.responses,
      [questionId]: this.ratingForQuestion(questionId) === rating ? null : rating
    };

    this.setState({
      responses: updatedResponses
    });
  }

  ratingForQuestion(questionId){
    return this.state.responses[questionId];
  }

  itemsOnPageComplete(){
    const pageData = this.currentPageData();

    if(!pageData){
      return false;
    }

    let itemsComplete = true;

    _.each(pageData.allQuestions, question => {
      if(!this.ratingForQuestion(question.id)){
        itemsComplete = false;
      }
    });

    return itemsComplete;
  }

  renderLikertQuestion(question){

    let itemDescriptionContent = null;

    if(question.itemDescription){
      itemDescriptionContent = <small><br/>{question.itemDescription}</small>
    }

    return (
      <div key={`likert-question-${question.id}`} className="question likert">
        <div className="question-text">{this.questionText(question)}{itemDescriptionContent}</div>
        <div className="question-score">
          <StarRating
            ratingLabel=""
            maxRating={7}
            currentRating={this.ratingForQuestion(question.id)}
            updateRating={rating => { this.updateRatingForQuestion(question.id, rating); }}
            ratingExplanations={LIKERT_RATING_EXPLANATIONS}
            includeRatingExplanationPlaceholder={true}
            />
        </div>
      </div>
    );
  }

  ratingTiers(competencyIndex){
    const mappedTiers = _.map(RATING_TIERS, tier => {

      let competencyName;

      if(competencyIndex){
        competencyName = getSellingCompetency(competencyIndex).name;
      }
      else{
        //generic description
        competencyName = null;
      }

      const descriptionWithCompetencyStringReplaced = _.replace((competencyIndex ? tier.competencyDescription : tier.description), /COMPETENCY_PLACEHOLDER/g, competencyName);
      const descriptionWithCompetencyStringAndNameReplaced = _.replace(descriptionWithCompetencyStringReplaced, /NAME_PLACEHOLDER/g, this.sellerName());

      return {
        ...tier,
        description: descriptionWithCompetencyStringAndNameReplaced,
      }
    });

    return mappedTiers;
  }

  ratingTier(competencyIndex, value){
    return _.find(this.ratingTiers(competencyIndex), { value });
  }

  likertCompleteForCurrentPage(){
    let complete = true;

    _.each((this.currentPageData() || {}).likertQuestions || [], question => {
      if(!this.ratingForQuestion(question.id)){
        complete = false;
      }
    });

    return complete;
  }

  renderTierRatingForQuestion(question){

    const currentRatingForQuestion = this.state.hoveringTier || this.ratingForQuestion(question.id);

    return (
      <React.Fragment>
        <div className="tier-rating">
          {_.map(this.ratingTiers(question.competencyIndex), tier => {

            const selectedClass = currentRatingForQuestion === tier.value ? 'selected' : '';

            return (
              <div
                key={`tier-${tier.value}`}
                onClick={() => { this.updateRatingForQuestion(question.id, tier.value); }}
                onMouseEnter={() => { this.setState({ hoveringTier: tier.value }); }}
                onMouseLeave={() => { this.setState({ hoveringTier: null }); }}
                className={`tier tier-${tier.value}-bg tier-${tier.value}-border ${selectedClass}`}
              >{tier.label}</div>
            )
          })}
        </div>
        <div className="tier-distribution">
          {_.map(this.ratingTiers(question.competencyIndex), tier => {

            const selectedClass = currentRatingForQuestion === tier.value ? 'selected' : '';

            return (
              <div key={`tier-${tier.value}`} className={`tier tier-${tier.value}-bg ${selectedClass}`} style={{ width: `${tier.proportion}%` }}></div>
            )
          })}
        </div>
      </React.Fragment>
    )
  }

  sellerName(){
    return this.props.viewingUser ? this.props.viewingUser.firstName : (this.props.user || {}).firstName || '';
  }

  hasAnsweredAtLeastOneTierQuestion(){
    let hasAnsweredAtLeastOne = false;

    _.each(_.filter(this.props.salesCompetencyReviewItems, { ratingType: 'tier' }), question => {
      if(hasAnsweredAtLeastOne){ return; }
      else if(this.ratingForQuestion(question.id)){
        hasAnsweredAtLeastOne = true;
      }
    });

    return hasAnsweredAtLeastOne;
  }

  questionText(question){
    return this.props.isOwnReview ? question.sellerText : question.managerText;
  }

  renderTierQuestion(question){
    const {
      questionType,
      competencyIndex,
    } = question;

    const questionRating = this.ratingForQuestion(question.id);

    const { label } = this.ratingTier(competencyIndex, questionRating) || {};
    const { description } = this.ratingTier(competencyIndex, this.state.hoveringTier || questionRating) || {};

    const isDisabled = !this.likertCompleteForCurrentPage();

    return (
      <div key={`tier-question-${question.id}`} className={`question tier ${isDisabled ? 'disabled' : ''}`}>
        <div className={`current-tier tier-${questionRating}-bg`}>Rank: {label ? label : 'Pending'}</div>
        <div className="question-text">{this.questionText(question)}</div>
        {questionType === 'competency' &&
          <div className="question-text">Based on these characteristics, how would you rate {`${this.sellerName()}\'`}s overall strength in {getSellingCompetency(competencyIndex).name}?</div>
        }
        {!questionType &&
          <div className="question-text">Based on these characteristics, how would you rate {`${this.sellerName()}\'`}s overall strength in Critical Expertise?</div>
        }
        {!this.hasAnsweredAtLeastOneTierQuestion() &&
          <div className="question-tip">Select a rating below...</div>
        }
        <div className="question-score">
          {this.renderTierRatingForQuestion(question)}
        </div>
        <div className="rating-description" style={{minHeight: 90}}>{description}</div>
      </div>
    );
  }

  currentPageData(){
    const {
      currentReviewPage
    } = this.state;

    return this.reviewPages()[currentReviewPage] || null;
  }

  renderCurrentReviewPage(){

    const pageData = this.currentPageData();

    if(!pageData){
      return null;
    }

    const {
      pageType,
      competency,
      likertQuestions,
      tierQuestions,
      notesPrompt,
    } = pageData;

    const matchingCompetency = getSellingCompetency(competency);

    return (
      <div className="review-page">
        {pageType === 'competency' &&
          <React.Fragment>
            <h5>Competency {competency}/10</h5>
            <h2>{getSellingCompetency(competency).name}</h2>
          </React.Fragment>
        }
        {pageType === 'expertise' &&
          <h2>Critical Expertise</h2>
        }
        {pageType === 'coachability' &&
          <h2>Coachability</h2>
        }
        {pageType === 'notes' &&
          <h2>Notes</h2>
        }
        {pageType === 'research' &&
          <h2>Research Questions</h2>
        }
        {pageType !== 'notes' &&
          <div className="instructions">Rate {this.props.isOwnReview ? 'yourself' : this.sellerName()} on the following statements on a scale from Very Strongly Disagree (1 Star) to Very Strongly Agree (7 Stars)</div>
        }

        {!this.props.isOwnReview && this.isOnFinalPage() &&
          <div className="instructions"><b>These questions are for research purposes only, and will not be shared with this seller or anyone at your organization.</b></div>
        }

        {_.size(likertQuestions) > 0 &&
          <div className="questions-block">
            {_.map(likertQuestions, this.renderLikertQuestion.bind(this))}
          </div>
        }
        {_.size(tierQuestions) > 0 &&
          <div className="questions-block">
            {_.map(tierQuestions, this.renderTierQuestion.bind(this))}
          </div>
        }
        {notesPrompt &&
          <div className="freeform-block">
            <div className="freeform-question">{notesPrompt}</div>
            <textarea className="freeform-answer" value={this.state.responses['notes'] || ''} onChange={e => { this.updateRatingForQuestion('notes', e.target.value); }}></textarea>
          </div>
        }
      </div>
    )
  }

  updatedReviewResponsesForRole(){
    //return updated sellerResponses object, or reviewerResponses object, based on current user role
    return {
      ...(this.props.isOwnReview && { sellerResponses: this.state.responses }),
      ...(!this.props.isOwnReview && { reviewerResponses: this.state.responses }),
    }
  }

  otherPersonHasCompleted(){
    return  this.props.isOwnReview && this.props.editingReview.reviewerStatus === 'complete' ||
            !this.props.isOwnReview && this.props.editingReview.sellerStatus === 'complete';
  }

  onComplete(){
    if(this.otherPersonHasCompleted()){
      //view report now
      this.setState({
        redirectTo: 'view'
      });
    }
    else{
      //go home - as report not ready yet
      this.setState({
        redirectTo: 'home'
      });
    }
  }

  saveAndAdvancePage(){
    if(this.state.saving){ return; }
    this.setState({ saving: true });

    if(!this.isOnFinalPage()){
      this.props.updateSalesCompetencyReview(this.props.editingReview._id, this.updatedReviewResponsesForRole(), this.props.isOwnReview, () => {
        this.setState({
          saving: false,
          currentReviewPage: this.state.currentReviewPage + 1
        });

        scrollTop();
      });
    }
    else{
      this.props.completeSalesCompetencyReview(this.props.editingReview._id, this.updatedReviewResponsesForRole(), this.props.isOwnReview, this.onComplete.bind(this));
    }
  }
  saveAndGoBack(){
    if(this.state.saving){ return; }
    this.setState({ saving: true });

    this.props.updateSalesCompetencyReview(this.props.editingReview._id, this.updatedReviewResponsesForRole(), this.props.isOwnReview, () => {
      this.setState({
        saving: false,
        currentReviewPage: this.state.currentReviewPage - 1
      });
      scrollTop();
    });
  }

  advanceUserToFirstIncompletePage(){
    console.log('advanceUserToFirstIncompletePage: ');

    let firstPageWithMissingResponses;

    _.each(this.reviewPages(), (page, pageIndex) => {

      //if already found page, skip
      if(firstPageWithMissingResponses !== undefined){
        console.log('firstPageWithMissingResponses: ', firstPageWithMissingResponses);
        return;
      }

      let pageHasMissingResponses = false;

      console.log('checking questions: ', page.allQuestions);

      _.each(page.allQuestions, question => {
        if(!this.ratingForQuestion(question.id)){
          pageHasMissingResponses = true;
        }
      });

      console.log('pageHasMissingResponses: ', pageHasMissingResponses);

      if(pageHasMissingResponses){
        firstPageWithMissingResponses = pageIndex;
      }
    });

    console.log('firstPageWithMissingResponses: ', firstPageWithMissingResponses);

    this.setState({
      currentReviewPage: firstPageWithMissingResponses || 0,
    });
  }

  componentWillMount(){

    const { match: { params } } = this.props;

    this.props.fetchSalesCompetencyReview(params.reviewId, review => {
      this.setState({
        responses: this.props.isOwnReview ? this.props.editingReview.sellerResponses : this.props.editingReview.reviewerResponses
      }, () => {
        this.advanceUserToFirstIncompletePage();
      });
    });

    //fetch review items if we don't already have
    if(!this.props.salesCompetencyReviewItems){
      this.props.fetchSalesCompetencyReviewItems();
    }
  }

  isOnFinalPage(){
    return this.state.currentReviewPage === _.size(this.reviewPages()) - 1;
  }

  autofillCurrentPage(){

    const pageData = this.currentPageData();

    if(!pageData){
      return null;
    }

    const {
      likertQuestions,
      tierQuestions,
    } = pageData;

    let updatedResponses = { ...this.state.responses }

    _.each(likertQuestions, question => {
      updatedResponses[question.id] = Math.ceil(Math.pow(Math.random(), .5) * 7);
    });

    _.each(tierQuestions, question => {
      updatedResponses[question.id] = Math.ceil(Math.pow(Math.random(), .5) * 7);
    })

    this.setState({
      responses: updatedResponses
    }, () => {
      this.saveAndAdvancePage();
    });
  }

  renderConfirmResearchQuestionExplanation(){
    const { hasConfirmedResearchQuestionExplanation } = this.state;

    if(!this.isOnFinalPage() || this.props.isOwnReview || hasConfirmedResearchQuestionExplanation){
      return null;
    }

    return (
      <ConfirmModal
        iconKey='research'
        confirmText='Continue'
        messageHtml={`<p>The questions on the following page are for <b>RESEARCH PURPOSES ONLY</b>.</p><p>The results will not be shared with the seller, or anyone else in your company. Please answer honestly, as we will use insights derived from characteristics of high/low performers to custom tailor advice for teams you run and your organization as a whole.</p>`}
        onConfirm={() => { this.setState({ hasConfirmedResearchQuestionExplanation: true }); } }
        hide={() => { this.setState({ hasConfirmedResearchQuestionExplanation: true }); } }
        hideCancel={true}
        visible={true}
      />
    )
  }

  render(){

    const {
      loadingPredictiveSkillsReviewItems,
      loadingPredictiveSkillsReview,
      editingReview,
    } = this.props;

    const {
      currentReviewPage,
      saving,
      responses,
      redirectTo,
    } = this.state;

    if(redirectTo){ return <Redirect to={redirectTo === 'view' ? `${navPrefix()}/salesCompetencies/view/${editingReview._id}` : `${navPrefix()}/salesCompetencies`} /> }

    return (
      <Page pageClass="sales-competency-review" loading={loadingPredictiveSkillsReviewItems || loadingPredictiveSkillsReview || !editingReview || !responses}>
        <div className="taking-review">
          <div className="review-page">
            {this.renderCurrentReviewPage()}
            {this.renderConfirmResearchQuestionExplanation()}
          </div>
          <div className="review-actions">
            {currentReviewPage >= 1 &&
              <button
                disabled={saving}
                onClick={this.saveAndGoBack.bind(this)} className="back button grey-outline">Back</button>
            }
            <button
              disabled={saving || !this.itemsOnPageComplete()}
              onClick={this.saveAndAdvancePage.bind(this)} className="next button blue-button">{this.isOnFinalPage() ? 'Complete Review' : 'Next'}</button>
            {(emulatingDevelopment() || isDevelopment()) &&
              <button
                style={{marginRight: 15}}
                disabled={saving}
                onClick={this.autofillCurrentPage.bind(this)} className="next button blue-button">{this.isOnFinalPage() ? 'Autofill & Complete' : 'Autofill Page'}</button>
            }
          </div>
        </div>
      </Page>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data,
    organization: state.organization.data,
    predictiveSkillsItems: state.salesCompetencyReviewItems.items,
    loadingPredictiveSkillsReviewItems: state.salesCompetencyReviewItems.loading,
    viewingUser: state.viewingUser.data,
    editingReview: state.viewingSalesCompetencyReview.currentReview,
    loadingPredictiveSkillsReview: state.viewingSalesCompetencyReview.loading,
    isOwnReview: !state.viewingUser.data,
    scoredCriticalExpertiseItems: ScoredCriticalExpertiseItemsSelector(state),
  }
}

export default connect(mapStateToProps, { fetchSalesCompetencyReviewItems, fetchSalesCompetencyReview, updateSalesCompetencyReview, completeSalesCompetencyReview })(EditingReview);



// WEBPACK FOOTER //
// ./src/components/salesCompetencies/editSalesCompetencyReview.js